/* eslint-disable import/prefer-default-export */

import { getItemsForEstimate } from './getItemsForEstimate';

export const getInvalidItemsCount = (entities, estimateId) =>
  getItemsForEstimate(entities, estimateId).reduce(
    (acc, item) => (item.itemProduct && !item.itemProduct.isValid ? acc + 1 : acc),
    0,
  );
